
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-mawoo-pets",
      function () {
        return require("private-next-pages/why-mawoo-pets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-mawoo-pets"])
      });
    }
  